<template>
    <div id="row" class="d-flex flex-row align-items-left">
        <div class="col1">
          <div class="row1 d-flex flex-rows justify-content-between align-items-center">
            <div class="lg1">
              <div class="type">{{type.lg1}}</div>
              <div class="sublabel">{{sublabel.lg1}}</div>
            </div>
          </div>
        </div>
        <div class="col2">
            <div class="price float-right d-flex flex-rows justify-content-between align-items-center">{{price1}}</div>
        </div>
        <div class="col3">
            <div class="price float-right d-flex flex-rows justify-content-between align-items-center">{{price2}}</div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'IbisStylesRatesHorizontalV1RatesRow',
  props: {
    ratesLg1: Object,
    ratesLg2: Object
  },
  computed: {
    type () {
      return {lg1: this.ratesLg1[0].label_value, lg2: this.ratesLg2[0].label_value}
    },
    sublabel () {
      return {lg1: this.ratesLg1[0].sub_label, lg2: this.ratesLg2[0].sub_label}
    },
    price1 () {
      return this.ratesLg1[0].mrr_value
    },
    price2 () {
      return this.ratesLg1[1].mrr_value
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibisstyles.scss";

#row {
  width: 100%;
  @include heightPercent(109);

  .row1 {
    margin-top: 0.3vh;
    height: 100%;

    .lg1 {
      overflow: hidden;
      color: black;

      .sublabel {
        font-family: "Gotham-BookItalic";
        @include fontSize(28);
        margin-top: -10px;
      }

      .type {
        font-family: "Gotham-Book";
        &::first-letter {
           text-transform: uppercase;
         }
        @include fontSize(46);
      }
    }
  }

    .price {
        font-family: "Gotham-Bold";
        @include fontSize(46);
        white-space: nowrap;
        height: 100%;
    }

    .col1 {
        @include widthPercent(509);
        @include marginPercent(0, 20, 0, 0);
    }

    .col2 {
        @include widthPercent(210);
        @include marginPercent(0, 10, 0, 0);
    }

    .col3 {
        @include widthPercent(210);
        @include marginPercent(0, 10, 0, 0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ibisstyles/rates/horizontal/v1/rates/rowRates.vue